import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";

export const Route = createFileRoute("/connectors/")({
  component: ConnectorsIndex,
});

/**
 * Client-side redirect to the connectors product page.
 *
 * The real redirect is a CDN-level 301 in staticwebapp.config.json, so a
 * crawler or a cold visit never reaches this component. Note there is ONE rule,
 * not two: Azure Static Web Apps normalises the trailing slash itself and
 * rejects `/connectors/` as a duplicate route, failing the deploy outright. It remains for in-app navigation, where the router resolves
 * the route client-side and the CDN is never consulted. /connectors is
 * deliberately absent from the sitemap
 * and from PRERENDER_ROUTES - prerendering a client-side redirect produced
 * either an empty <title> or no output file, depending on whether the snapshot
 * beat the redirect.
 *
 * The Helmet block is belt-and-braces for the brief moment this renders during
 * an in-app navigation; the canonical names the redirect target.
 */
function ConnectorsIndex() {
  return (
    <>
      <Helmet>
        <title>Connectors | Larasoft</title>
        <link
          rel="canonical"
          href="https://larasoft.global/connectors/product"
        />
      </Helmet>
      <Navigate to="/connectors/product" replace />
    </>
  );
}
